import {ROUTE_PATHS} from '@/router/routePaths.ts';
import {TOAST_CONFIG} from '@/shared/constants.ts';
import {UserRole} from '@/shared/types/common.ts';
import {
    CalendarDays,
    Clock3,
    CreditCard,
    DollarSign,
    LayoutDashboard,
    Pencil,
    TrendingUp,
    Users,
    UsersRound,
} from 'lucide-react';
import {useCallback, useMemo} from 'react';
import {NavLink} from 'react-router';

type TabConfig = {
    path: string;
    label: string;
    icon: typeof Users;
};

const RECEPTIONIST_TABS: TabConfig[] = [
    {path: ROUTE_PATHS.RECEPTIONIST.PAGAMENTO, label: 'Pagamento', icon: CreditCard},
    {
        path: ROUTE_PATHS.RECEPTIONIST.PAGAMENTOS_PENDENTES,
        label: 'Pendente',
        icon: Clock3,
    },
    {path: ROUTE_PATHS.RECEPTIONIST.CLIENTES, label: 'Clientes', icon: Users},
    {path: ROUTE_PATHS.RECEPTIONIST.EDITAR, label: 'Editar', icon: Pencil},
];

const EMPLOYEE_TABS: TabConfig[] = [
    {path: ROUTE_PATHS.EMPLOYEE.RESUMO, label: 'Resumo - Dia', icon: LayoutDashboard},
    {
        path: ROUTE_PATHS.EMPLOYEE.PAGAMENTOS_PENDENTES,
        label: 'Pendente',
        icon: Clock3,
    },
    {path: ROUTE_PATHS.EMPLOYEE.FECHAMENTO, label: 'Fechamento', icon: DollarSign},
];

const OWNER_TABS: TabConfig[] = [
    {path: ROUTE_PATHS.OWNER.CLIENTES, label: 'Clientes', icon: Users},
    {path: ROUTE_PATHS.OWNER.PAGAMENTOS_PENDENTES, label: 'Pendente', icon: Clock3},
    {path: ROUTE_PATHS.OWNER.DIARIO, label: 'Diário', icon: CalendarDays},
    {path: ROUTE_PATHS.OWNER.COMISSAO, label: 'Comissão', icon: UsersRound},
    {path: ROUTE_PATHS.OWNER.FLUXO, label: 'Fluxo', icon: TrendingUp},
];

const TABS_BY_ROLE: Record<UserRole, TabConfig[]> = {
    receptionist: RECEPTIONIST_TABS,
    employee: EMPLOYEE_TABS,
    owner: OWNER_TABS,
};

type DockProps = {
    role: UserRole;
};

export const Dock = ({role}: DockProps) => {
    const tabs = useMemo(() => {
        return TABS_BY_ROLE[role] || [];
    }, [role]);

    const handleTabClick = useCallback(() => {
        // Haptic feedback
        if ('vibrate' in navigator) {
            navigator.vibrate(TOAST_CONFIG.HAPTIC_DURATION_MS);
        }
    }, []);

    return (
        <nav className="dock">
            {tabs.map((tab) => {
                const Icon = tab.icon;

                return (
                    <NavLink
                        key={tab.path}
                        to={tab.path}
                        className={({isActive}) => `dock-tab ${isActive ? 'active' : ''}`}
                        onClick={handleTabClick}
                    >
                        {({isActive}) => (
                            <>
                                <Icon size={24} strokeWidth={isActive ? 2.5 : 2} />
                                <span>{tab.label}</span>
                            </>
                        )}
                    </NavLink>
                );
            })}
        </nav>
    );
};

export {RECEPTIONIST_TABS, EMPLOYEE_TABS, OWNER_TABS};
